import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

export const getOpenBoardFilterSheetStyles = (theme: Theme) =>
  StyleSheet.create({
    scrim: {
      flex: 1,
      backgroundColor: theme.background.overlay,
      justifyContent: 'flex-end',
    },
    sheet: {
      backgroundColor: theme.background.card,
      borderTopLeftRadius: 20,
      borderTopRightRadius: 20,
      borderTopWidth: 1,
      borderColor: theme.gray[200],
      paddingHorizontal: 18,
      paddingTop: 14,
      gap: 18,
      maxHeight: '92%',
    },
    sheetContent: {
      gap: 18,
    },
    grabber: {
      width: 40,
      height: 4,
      borderRadius: 999,
      backgroundColor: theme.gray[300],
      alignSelf: 'center',
    },
    headerRow: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    title: {
      fontSize: 18,
      fontWeight: '800',
      color: theme.black,
    },
    reset: {
      fontSize: 13,
      fontWeight: '700',
      color: theme.primary,
    },
    resetPressed: {
      opacity: 0.7,
    },

    section: {
      gap: 9,
    },
    sectionHeaderRow: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 12,
    },
    sectionLabel: {
      fontSize: 10,
      fontWeight: '800',
      letterSpacing: 1,
      color: theme.gray[400],
    },
    /** The section the chip asked for: it leads the sheet and says so. */
    sectionLabelFocused: {
      color: theme.primaryLight,
    },
    sectionValue: {
      fontSize: 12,
      fontWeight: '700',
      color: theme.accent,
    },
    optionWrap: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      gap: 8,
    },
    option: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 6,
      minHeight: 40,
      paddingHorizontal: 13,
      paddingVertical: 8,
      borderRadius: 10,
      backgroundColor: theme.background.inset,
      borderWidth: 1,
      borderColor: theme.gray[200],
    },
    optionSelected: {
      backgroundColor: theme.primary,
      borderColor: theme.primary,
    },
    optionPressed: {
      opacity: 0.85,
    },
    optionLabel: {
      fontSize: 13,
      fontWeight: '700',
      color: theme.gray[600],
    },
    optionLabelSelected: {
      color: theme.onPrimary,
    },
    optionBadge: {
      width: 16,
      height: 16,
    },

    /** Size sits in a 3-up row: the options are peers, not a wrapping list. */
    sizeRow: {
      flexDirection: 'row',
      gap: 8,
    },
    sizeOption: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      gap: 3,
      minHeight: 56,
      borderRadius: 10,
      backgroundColor: theme.background.inset,
      borderWidth: 1,
      borderColor: theme.gray[200],
    },
    sizeLabelRow: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 4,
    },
    sizeCrown: {
      width: 12,
      height: 12,
    },
    sizeHint: {
      fontSize: 10,
      fontWeight: '600',
      color: theme.gray[400],
    },
    sizeHintSelected: {
      color: theme.onPrimary,
      opacity: 0.7,
    },

    applyButton: {
      minHeight: 48,
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: 10,
      backgroundColor: theme.primary,
      marginBottom: 22,
    },
    applyPressed: {
      opacity: 0.85,
    },
    applyText: {
      fontSize: 15,
      fontWeight: '800',
      color: theme.onPrimary,
    },
  });
